import * as React from "react";
import Font from "@/src/components/base/Font";
import style from "./style.module.scss";
import { Color } from "@/src/styles/typescript/types/color";

export default function Avatar({
  children = "",
  shape = "circle",
  size = "md",
  src = "",
  background = "blue1",
  color = "blue8",
}: {
  children?: string;
  shape?: "hexagonal" | "circle";
  size?: "lg" | "md";
  src?: string;
  background?: Color;
  color?: Color;
}) {
  return (
    <div
      className={`${style.avatar} ${
        shape === "hexagonal"
          ? style["avatar--hexagonal"]
          : style["avatar--circle"]
      } ${style["avatar-size--" + size]} ${
        src.length === 0 ? style["avatar-color--" + background] : ""
      } ${src.length === 0 ? style["avatar-border"] : ""}`}
      style={{
        backgroundImage: src.length !== 0 ? `url(${src})` : "none",
        backgroundSize: "cover",
      }}
    >
      <Font variant={"heading-2-semibold"} color={color}>
        {children}
      </Font>
    </div>
  );
}
